// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".config-box[data-v-39f1b27c] {\n  border-bottom: 1px solid #ebeef5;\n}\n.config-title[data-v-39f1b27c]:before {\n  content: '';\n  position: absolute;\n  top: 4px;\n  left: -5px;\n  width: 2px;\n  border-radius: 20%;\n  background-color: #653EB3;\n  height: 18px;\n}\n", ""]);
// Exports
module.exports = exports;
